import { backendBaseUrl } from '../utils/platformBasedInfo';
import { useAxios } from './axiosInstance';
import { UseAxiosResult } from 'axios-hooks';
import { useEnrichWithCommonValues } from './enrichWithCommonValues';

export const ENDPOINT_PLAID_CONNECT = `${backendBaseUrl}/tools/plaid/connect`;

export const plaidConnect = (): UseAxiosResult => {
  const { enrich } = useEnrichWithCommonValues();
  const [{ data, loading, error }, update] = useAxios(
    {
      url: ENDPOINT_PLAID_CONNECT,
      withCredentials: true,
      method: 'POST',
    },
    { manual: true }
  );

  return [{ data, loading, error }, enrich(update), () => {}];
};
